import { render } from "./TeamFormDots.vue?vue&type=template&id=1ffa572e&scoped=true"
import script from "./TeamFormDots.vue?vue&type=script&lang=js"
export * from "./TeamFormDots.vue?vue&type=script&lang=js"

import "./TeamFormDots.vue?vue&type=style&index=0&id=1ffa572e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffa572e"]])

export default __exports__